import React, { ReactElement } from "react";
import dynamic from "next/dynamic";

const DownloadApp = dynamic<ComponentProps>(
  () => {
    return import("./downloadApp").then((module) => module.DownloadApp);
  },
  { ssr: false }
);

const NoResultDownloadApp = dynamic<ComponentProps>(
  () => {
    return import("./noResultDownloadApp").then(
      (module) => module.NoResultDownloadApp
    );
  },
  { ssr: false }
);

const HomeDownloadApp = dynamic<ComponentProps>(
  () => {
    return import("./homeDownloadApp").then((module) => module.HomeDownloadApp);
  },
  { ssr: false }
);

export const InstallComponentLoader = (props: Props): ReactElement => {
  if (props.type === "downloadApp") return <DownloadApp {...props} />;
  if (props.type === "searchResultWithResult")
    return <DownloadApp {...props} />;
  if (props.type === "searchResultWithoutResult")
    return <NoResultDownloadApp {...props} />;
  if (props.type === "pages") return <HomeDownloadApp {...props} />;
};

interface Props {
  type:
    | "downloadApp"
    | "searchResultWithResult"
    | "searchResultWithoutResult"
    | "pages";
  isMobile: boolean;
  sendInstallComponentClickedEvent: (
    buttonType: "app_store" | "google_play"
  ) => void;
  className?: string;
}

interface ComponentProps {
  isMobile: boolean;
  sendInstallComponentClickedEvent: (
    buttonType: "app_store" | "google_play"
  ) => void;
  className?: string;
}

export default InstallComponentLoader;
